var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',_vm._g(_vm._b({attrs:{"type":_vm.type,"icon":"fa fa-fw fa-refresh"}},'el-button',_vm.$attrs,false),_vm.$listeners),[_vm._v(" 刷新 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }